module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    attrs: {
      "disabled": _vm.activePage === 1
    },
    on: {
      "click": function($event) {
        return _vm.first()
      }
    }
  }, [_vm._v("<< PRVA")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "disabled": _vm.activePage === 1
    },
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_vm._v("< PRETHODNA ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (page + _vm.offset > _vm.activePage && page - _vm.offset < _vm.activePage),
        expression: "page + offset > activePage && page - offset < activePage"
      }]
    }, [_c('a', {
      class: {
        'active': page === _vm.activePage
      },
      on: {
        "click": function($event) {
          return _vm.goToPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "disabled": _vm.activePage === _vm.pages
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v(" SLEDECA >")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "disabled": _vm.activePage === _vm.pages
    },
    on: {
      "click": function($event) {
        return _vm.last()
      }
    }
  }, [_vm._v("POSLEDNJA >>")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-490a7cc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Pagination/Pagination.vue
// module id = 478
// module chunks = 1